import { plural } from "@web-monorepo/i18n/macro";
import { useState } from "react";
import { appMetadataList, RECEIVE_LIST } from "src/pods/list";
import EditableToolContainer from "src/pods/toolkitData/components/EditableToolContainer";
import SavedToolButton from "src/pods/toolkitData/components/SavedToolButton";
import styles from "./DirectionsRemoteContainer.module.css";
import DirectionsEditor from "./DirectionsEditor";
import DirectionsSenderDisplay from "./DirectionsSenderDisplay";

type DirectionsRemoteContainerProps = {
  params: {
    classId: string;
    mountPoint: string;
    app: string;
  };
};

export default function DirectionsRemoteContainer(props: DirectionsRemoteContainerProps) {
  const [focusOnParent, setFocusOnParent] = useState(true);

  return (
    <EditableToolContainer
      toolType="directions"
      appMetadata={appMetadataList()}
      {...props}
      focusOnParent={focusOnParent}
      setFocusOnParent={setFocusOnParent}
      renderItem={({ tool, openEditScreen, showTool }) => {
        const { list, title } = tool.payload;
        const count = list ? list.length : 0;
        const text = title ? title : count > 0 ? list?.[0].text : "";
        return (
          <SavedToolButton
            data-name={`directions_remote_container:steps_in_list:${tool._id}`}
            key={tool._id}
            onRowClick={() => showTool(tool)}
            onEditClick={() => openEditScreen(tool)}
            buttonText={text}
          >
            <div className={styles.titleText}>{text}</div>
            <div className={styles.countText}>{plural(count, { one: "# step", other: "# steps" })}</div>
          </SavedToolButton>
        );
      }}
      renderEditItem={({ onEdit, payload }) => (
        <DirectionsEditor onEdit={onEdit} payload={payload} setFocusOnParent={setFocusOnParent} />
      )}
      renderResult={({ tool }) => {
        return <DirectionsSenderDisplay title={tool.title} list={tool.list} />;
      }}
      getDisplayPayload={(payload) => ({
        type: RECEIVE_LIST,
        payload,
      })}
    />
  );
}
